import { Stack, Text } from '@fluentui/react';
import { useClassNames, useTheme } from '@h2oai/ui-kit';

import { AuditTrailListRowClassNames, AuditTrailListRowStyles, auditTrailListRowStyles } from '../auditTrail.styles';
import { LogLabelProps, LogTextProps } from '../types';

export const LogLabel = ({ content }: LogLabelProps) => {
  if (!content) return null;
  return <div style={{ minWidth: 234 }}>{content}</div>;
};

export const LogText = (props: LogTextProps) => {
  const { content, truncate = true, expanded = false, header = false } = props;
  const theme = useTheme();
  const classNames = useClassNames<Partial<AuditTrailListRowStyles>, AuditTrailListRowClassNames>(
    'AuditTrailListRow',
    auditTrailListRowStyles(theme, expanded, header)
  );

  const classes: string[] = [classNames.logText];
  if (header) classes.push(classNames.header);
  if (!expanded) classes.push(classNames.collapsed);
  classes.push(expanded && !truncate ? classNames.expandedFullText : classNames.truncate);

  return (
    <Stack className={classNames.root}>
      <Text className={classes.join(' ')}>{content}</Text>
    </Stack>
  );
};
